export const getEncrypDecryptStr = (str, type) => {
  if (type === "encrypt" || type === "decrypt") {
    return type === "encrypt" ? btoa(encodeURIComponent(str)) : decodeURIComponent(atob(str));
  } else return str;
};
